import {UcoastEl} from "@/scripts/core/UcoastEl";
import { currentTargetRequired, getAttributeOrThrow, qsRequired } from '@/scripts/core/global'

export class QuantityInput extends UcoastEl {
	static htmlSelector = 'quantity-input'
	input: HTMLInputElement
	changeEvent: Event
	constructor() {
		super();
		this.input = qsRequired("input", this);

		this.changeEvent = new Event("change", { bubbles: true });

		this.querySelectorAll("button").forEach((button) =>
			button.addEventListener("click", this.onButtonClick.bind(this))
		);
	}

	onButtonClick(event: Event) {
		event.preventDefault();
		const previousValue = this.input.value;
		const currentTarget = currentTargetRequired(event)
		const currentTargetName = getAttributeOrThrow('name', currentTarget)

		if (currentTargetName === "plus") {
			this.input.stepUp();
		} else if (currentTargetName === "minus") {
			this.input.stepDown();
		} else {
			console.log("cart target error", event);
			return;
		}
		if (previousValue !== this.input.value) {
			this.input.dispatchEvent(this.changeEvent);
		}

	}

	onCloseButtonClick(event: Event) {
		event.preventDefault();
		if (this.input.value && this.input.value !== '0') {
			this.input.value = '0'
			this.input.dispatchEvent(this.changeEvent);
		}
	}
}
